import { PathHelper } from '@sensenet/client-utils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { loadItems } from "../components/tree-picker/loaders.js";
const setParentIdAndPath = (node, parent) => {
  return parent && parent.Id === node.Id ? {
    parentId: parent.ParentId,
    path: parent.Path
  } : {
    parentId: node.ParentId,
    path: node.Path
  };
};

/**
 * useTreePicker let you select and navigate in the repository with built in defaults
 */
export const useTreePicker = options => {
  // get defaults
  const {
    repository,
    currentPath = '',
    navigationPath
  } = options;
  const roots = useMemo(() => {
    var _options$selectionRoo;
    return (_options$selectionRoo = options.selectionRoots) === null || _options$selectionRoo === void 0 ? void 0 : _options$selectionRoo.filter((root, _index, original) => !original.some(item => PathHelper.isAncestorOf(item, root)));
  }, [options.selectionRoots]);
  const [{
    path,
    parentId
  }, dispatch] = useState({
    path: currentPath,
    parentId: undefined
  });
  const [reloadToken, setReloadToken] = useState(0);
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const reload = useCallback(() => {
    setReloadToken(Date.now());
  }, []);
  useEffect(() => {
    const abortController = new AbortController();
    (async () => {
      try {
        setIsLoading(true);
        const result = await loadItems({
          path: navigationPath || path,
          loadParent: !(roots !== null && roots !== void 0 && roots.includes(navigationPath || path)),
          repository,
          parentId,
          itemsODataOptions: options.itemsODataOptions,
          parentODataOptions: options.parentODataOptions,
          abortController
        });
        setItems(result);
      } catch (e) {
        if (!abortController.signal.aborted) {
          setError(e);
        }
      } finally {
        setIsLoading(false);
      }
    })();
  }, [repository, reloadToken, parentId, roots, options.itemsODataOptions, options.parentODataOptions, path, navigationPath]);
  const navigateTo = useCallback(node => dispatch(setParentIdAndPath(node, items === null || items === void 0 ? void 0 : items.find(c => c.isParent))), [items]);
  return {
    items,
    navigateTo,
    path,
    isLoading,
    error,
    reload
  };
};
//# sourceMappingURL=use-tree-picker.js.map